export default __webpack_public_path__ + "static/media/DOCX.1bc7d5d4.svg";